const approvalState = [
	{
		text: '', key: 'text.undecided', value: 0, color: 'grey',
	},
	{
		text: '', key: 'text.approvalStateItems.approved', value: 1, color: 'green',
	},
	{
		text: '', key: 'text.approvalStateItems.declined', value: 2, color: 'red',
	},
];

function getApprovalState(_this) {
	approvalState.forEach((x) => {
		x.text = _this.$t(x.key);
	});
	return approvalState;
}

export default getApprovalState;
